import { Dictionary, Nullable } from '@utils/util.types';
import { create } from 'zustand';
import {
	createUser,
	CreateUserPayload,
	deleteUser,
	updateUser,
	UpdateUserPayload,
} from './usersService';

interface Company {
	id: string;
	user_id: string;
	company_name: string;
	company_id: string;
	created_at: string;
	updated_at: string;
}

interface SocialLink {
	id: string;
	user_id: string;
	link: Record<string, any>;
	created_at: string;
	updated_at: string;
}

interface FileType {
	fileType: string;
	filename: string;
	id: string;
	file_section: 'recommendation' | '';
	s3_key: string;
}

export interface Crop {
	id: string;
	image_url: string;
	name: string;
}
export interface User {
	id: string;
	user_id: string;
	user_completed_registration: boolean;
	first_name: string;
	last_name: string;
	phone: string;
	country: string;
	is_company: boolean;
	is_active: boolean;
	connection_code: string;
	user_agreed_term_and_condition: boolean;
	settings: null | Record<string, any>;
	profile_image: null | string;
	created_at: string;
	updated_at: string;
	user_crops: Crop[];
	user_languages: Dictionary[];
	user_files: FileType[];
	company: Company;
	social_link: SocialLink;
	user_specialties: Dictionary[];
	role: string;
	email: string;
	about: string;
	working_experience: {
		country: string;
		year: string;
	}[];
	unicode: {
		alpha_two: string;
		alpha_three: string;
	};
}

interface UsersState {
	user: Nullable<User>;
	loading: boolean;
	error: string | null;
	setUser: (user: Nullable<User>) => void;
	createUser: (data: any) => Promise<void>;
	updateUser: (data: any) => Promise<void>;
	deleteUser: (id: number) => Promise<void>;
	setLoading: (loading: boolean) => void;
	userByIds: Nullable<User>;
	setUserByIds: (userByIds: Nullable<User>) => void;
}

export const useUsersStore = create<UsersState>((set) => ({
	user: null,
	loading: false,
	error: null,
	userByIds: null,

	setUser: (user: Nullable<User>) => {
		set({ user });
	},

	setLoading: (loading: boolean) => {
		set({ loading });
	},

	createUser: async (data: CreateUserPayload) => {
		try {
			await createUser(data);
		} catch (error) {
			set({ error: error.message });
		}
	},

	updateUser: async (data: UpdateUserPayload) => {
		try {
			await updateUser(data);
		} catch (error) {
			set({ error: error.message });
		}
	},

	deleteUser: async () => {
		try {
			await deleteUser();
		} catch (error) {
			set({ error: error.message });
		}
	},

	setUserByIds: (userByIds: Nullable<User>) => {
		set({ userByIds });
	},
}));
